var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChargePointsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2806_25184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3349 4.35327L14.7073 5.60847H15.9625L15.3349 6.8637",
    stroke: "#7E84A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6484 9.0596C16.3859 9.24413 16.9036 9.90687 16.9036 10.6672C16.9036 11.7567 16.9036 13.1391 16.9036 13.1391H19.4141C19.4141 13.1391 19.4141 9.8046 19.4141 6.97882C19.4141 4.6978 17.8607 2.70921 15.6484 2.15601L11.8828 1.2146V8.11819L15.6484 9.0596Z",
    stroke: "#7E84A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.884 2.15576L8.11841 1.21436V6.23518L11.884 7.17658V2.15576Z",
    stroke: "#7E84A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.585938 15.0224C0.585938 12.5976 2.55348 10.6292 4.97918 10.6292C7.40488 10.6292 9.37242 12.5976 9.37242 15.0224C9.37242 17.4472 11.3399 19.4156 13.7656 19.4156C16.1913 19.4156 18.1589 17.4472 18.1589 15.0224V13.1396",
    stroke: "#7E84A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8828 0.586914V8.74578",
    stroke: "#7E84A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2806_25184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargePointsIcon);
export default __webpack_public_path__ + "static/media/charge-points-icon.46fe1c29b6e5c0160fe64dad60c7645c.svg";
export { ForwardRef as ReactComponent };